import { toId } from "../utils"

export default {
  job: (job) => `job-${toId(job, true) || "unknown"}`,
  post: (post) => `post-${toId(post, true) || "unknown"}`,
  action: (action) => `action-${toId(action, true) || "unknown"}`,
  userNote: (user) => `user-note-${toId(user, true) || "unknown"}`,
}
